<template>
    <div class="content-mobile">
        <div v-if="success=='true'">
            <div  class="success-content">
                <img src="../../assets/img/mobile/success.png" alt="">
                <p>支付成功</p>
                <p class="price">支付金额：<span>￥{{price}}</span></p>
                <p class="order">订单号：{{orderId}}</p>
            </div>
            <div class="success-btn">
                <p class="continue"  @click="goStudy">返回</p>
            </div>
        </div>
        <div v-if="success=='time'">
            <div class="error-content">
                <img src="../../assets/img/mobile/warning.png" alt="">
                <p>支付异常</p>
                <p class="tips">抱歉，您的交易因超时已失败</p>
            </div>
            <div class="btn" @click="goBack">
                返回首页
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "payResultMobile",
        data () {
            return {
                success:'true',
                url:'',
                indexUrl:'',
                price:'',
                orderId:'',
            }
        },
        methods: {
            goBack() {
                window.location.href = this.indexUrl;
            },
            goStudy(){
                window.location.href = this.url;
            }
        },
        mounted:function () {
            if(this.$route.query.success){
                this.success = this.$route.query.success;
            }
            if(this.$route.query.url){
                this.url = this.$route.query.url;
            }
            if(this.$route.query.indexUrl){
                this.indexUrl = this.$route.query.indexUrl;
            }
            if(this.$route.query.price){
                this.price = this.$route.query.price;
            }
            if(this.$route.query.orderId){
                this.orderId = this.$route.query.orderId;
            }
        }
    }
</script>

<style scoped lang="scss">
    .content-mobile{
        padding: 1.08rem 0.3rem 0 0.3rem;
        background: #fff;
        height: 100vh;
        .success-content{
            text-align: center;
            font-size:0.4rem;
            font-weight:500;
            color:rgba(48,50,51,1);
            img{
                width: 1.66rem;
                height: 1.66rem;
                margin-bottom: 0.06rem;
                margin-top: 1.02rem;
            }
            .price{
                font-size:0.28rem;
                font-weight:400;
                color:rgba(102,102,102,1);
                margin: 0.2rem 0;
                span{
                    color:#FF4200
                }
            }
            .order{
                font-size:0.24rem;
                font-weight:400;
                color:rgba(153,153,153,1);
            }

        }
        .success-btn{
            .continue{
                margin: 0.57rem 0 0.4rem 0;
                width: 100%;
                height: 0.96rem;
                background:rgba(28,140,254,1);
                border-radius:0.06rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size:0.3rem;
                font-weight:500;
                color:rgba(255,255,255,1);
            }
        }
        .error-content{
            text-align: center;
            font-size:0.4rem;
            font-weight:500;
            color:rgba(48,50,51,1);
            img{
                width: 1.66rem;
                height: 1.66rem;
                margin-bottom: 0.06rem;
            }
            .tips{
                font-size:0.24rem;
                font-weight:400;
                color:rgba(153,153,153,1);
                margin-top: 0.2rem;
                margin-bottom: 0.57rem;
            }
        }
        .btn{
            width: 100%;
            height: 0.96rem;
            background:rgba(28,140,254,1);
            border-radius:0.06rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:0.3rem;
            font-weight:500;
            color:rgba(255,255,255,1);
        }
    }
</style>
